import {AuthProvider, useAuth} from "./providers/authprovider";
import Login from "./pages/Login";
import {createBrowserRouter, RouterProvider, Navigate} from "react-router-dom";
import {Goals} from "./pages/Goals";
import {MainApp} from "./pages/MainApp";
import {Guide} from "./pages/Guide";
import {Demo} from "./pages/Demo";
import {Settings} from "./pages/Settings";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import {DemoSettings} from "./pages/DemoSettings";
import {Terms} from "./pages/Terms";
import {DemoGoals} from "./pages/DemoGoals";
import {Brokers} from "./pages/Brokers";
import {Journal} from "./pages/Journal";

// Protected route component for admin-only pages
const AdminRoute = ({ children }) => {
    const auth = useAuth();
    
    // Show loading state while authentication is being checked
    if (auth.isLoading) {
        return <div>Loading...</div>;
    }
    
    const isAdmin = auth.currentUser?.email === "edtsech@gmail.com";
    
    if (!isAdmin) {
        return <Navigate to="/app" replace />;
    }
    
    return children;
};

export default function Root({children}) {
    const router = createBrowserRouter([
        // {
        //     path: "/home",
        //     element: <App />,
        // },
        {
            path: "/app/brokers",
            element: <AdminRoute><Brokers /></AdminRoute>,
        },
        {
            path: "/app/journal",
            element: <AdminRoute><Journal /></AdminRoute>,
        },
        {
            path: "/app/goals",
            element: <Goals />,
        },
        {
            path: "/app/terms",
            element: <Terms />
        },
        {
            path: "/demo/terms",
            element: <Terms mode={"demo"} />
        },
        {
            path: "/app",
            element: <MainApp />,
        },
        {
            path: "/app/settings",
            element: <Settings />,
        },
        {
            path: "/",
            element: <Login />,
        }, {
            path: "/login",
            element: <Login />,
        }, {
            path: "/signup",
            element: <Signup />,
        }, {
            path: "/forgot-password",
            element: <ForgotPassword />,
        }, {
            path: "/guide",
            element: <Guide />,
        }, {
            path: "/demo",
            element: <Demo />,
        },
        {
            path: "/demo/settings",
            element: <DemoSettings />,
        },
        {
            path: "/demo/goals",
            element: <DemoGoals />
        },
    ]);

    return (
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    )
}
